<!-- Alert -->
<div class="grid grid-cols-1 gap-3 mt-6 w-full h-fit" *ngIf="_multiAlertService._alerts.length > 0" >
    <ng-container *ngFor="let alert of _multiAlertService._alerts">
        <div [@fadeOut]="alert.progress >= 0 ? '*':'void'">
            <fuse-alert class="w-full"
                        (dismissedChanged)="handleCloseEvent($event, alert.id)"
                        [appearance]="'border'"
                        [showIcon]="true"
                        [type]="alert.type"
                        [dismissible]="true"
                        [@shake]="alert.type === 'error'">
                <span fuseAlertTitle>{{alert.title}}</span>
                {{alert.message}}
            </fuse-alert>
            <mat-progress-bar *ngIf="alert.progress > 0" mode="determinate" color="{{alert.type === 'warn' || alert.type === 'error'?'warn':'basic'}}" value="{{alert.progress}}" class="pl-1 -mt-1 opacity-60" #progressBar></mat-progress-bar>
        </div>
    </ng-container>
</div>


